module.exports = __webpack_public_path__ + "static/notification-d0ad9621416845ac8a7a9a4d4f2cc088.png";